import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { apiRequest } from "../../apiServices/allApi";
const $ = require("jquery");
$.Datatable = require("datatables.net");

const SucWithdraw = () => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL || "";
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState();
  const id = localStorage.getItem("id");

  let [limit, setLimit] = useState(20);

  const setpageLimit = (event) => {
    let key = event.target.value;
    setLimit(key);
  };
  const [pageNumber, setPageNumber] = useState(0);
  const [numberOfPages, setNumberOfPages] = useState(0);
  //user for searching..
  const [searchList, setSearchList] = useState(0);
  const [searchType, setSearchType] = useState("Phone");
  const [findByStatus, setFindByStatus] = useState(0);

  const mediaUrl = (imagePath) => {
    if (!imagePath) return "";
    const value = String(imagePath);
    if (/^https?:\/\//i.test(value)) return value;
    return `${baseUrl.replace(/\/$/, "")}/${value.replace(/^\/+/, "")}`;
  };

  //react paginate..
  const handlePageClick = async (data) => {
    let currentPage = data?.selected + 1;
    setPageNumber(currentPage);
    // scroll to the top
  };

  //   searching handler
  const searchHandler = (event) => {
    let key = event.target.value;
    setSearchList(key);
  };
  //   search by status handler
  const searchByStatus = (event) => {
    setSearchType("0");
    let key = event.target.value;
    setFindByStatus(key);
  };

  const profle = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(
        `admin/txn/withdraw_admin/all?page=${pageNumber}&_limit=${limit}&_q=${searchList}&_stype=${searchType}&_status=${findByStatus}`,
        "GET",
        null,
        headers,
      );
      setUser(res.data?.data);
      setNumberOfPages(res.data?.totalPages);
    } catch (error) {
    } finally {
    }
  };

  const universalCheckPayout = (
    payment_gateway,
    txn_id,
    referenceId,
    userID,
  ) => {
    if (!referenceId) {
      alert("Payout txn id not found");
    }
    if (payment_gateway == "qrologic") {
      checkqrologic(txn_id, referenceId, userID);
    } else {
      alert("Nothing found");
    }
  };

  const checkqrologic = async (txn_id, referenceId, userID) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(
        `qrologic/txnstatus`,
        "POST",
        { txn_id, referenceId, userID },
        headers,
      );
      const icon = res.data?.status == "SUCCESS" ? "success" : "danger";
      const title = res.data?.message;

      profle();
      Swal.fire({
        title: title,
        icon: icon,
        confirmButtonText: "OK",
      });
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
      }
    } finally {
    }
  };

  const dateFormat = (e) => {
    const date = new Date(e);
    const newDate = date.toLocaleString("default", {
      month: "long",
      day: "numeric",
      hour: "numeric",
      hour12: true,
      minute: "numeric",
    });
    return newDate;
  };

  useEffect(() => {
    profle();
  }, [pageNumber, limit, searchList, searchType, findByStatus]);

  if (user == undefined) {
    return null;
  }
  return loading ? null : (
    <>
      <div className="row mt-4">
        <div className="col-12 grid-margin">
          <div className="card">
            <div className="card-body p-2">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="dashboard_heading m-0 text-primary">
                  <i className="mdi mdi-history text-primary mr-2"></i>{" "}
                  Withdrawals History
                </h4>
                <span className="badge badge-success px-3 py-2">
                  Processed Withdrawals
                </span>
              </div>

              {/* searching */}
              <div className="admin-filter-bar">
                <select
                  className="form-control"
                  style={{ maxWidth: "180px" }}
                  id="searchType"
                  name="searchtype"
                  onChange={(e) => setSearchType(e.target.value)}
                >
                  <option value="Phone">Search by Phone</option>
                  <option value="Name">Search by Name</option>
                  <option value="account_number">Search by Account No</option>
                  <option value="upiId">Search by UPI ID</option>
                  <option value="amount">Search by Amount</option>
                </select>

                <input
                  type="text"
                  placeholder="Search user or account..."
                  className="form-control"
                  style={{ flex: "1", minWidth: "180px" }}
                  onChange={searchHandler}
                />

                <select
                  className="form-control"
                  style={{ maxWidth: "170px" }}
                  id="findByStatus"
                  name="findByStatus"
                  onChange={searchByStatus}
                >
                  <option value="0">Filter by Status</option>
                  <option value="SUCCESS">SUCCESS</option>
                  <option value="FAILED">FAILED</option>
                  <option value="Pending">Pending</option>
                  <option value="reject">Rejected</option>
                </select>

                <select
                  className="form-control"
                  id="pagelimit"
                  name="pagelimit"
                  value={limit}
                  onChange={setpageLimit}
                >
                  <option value="10">10 / page</option>
                  <option value="20">20 / page</option>
                  <option value="50">50 / page</option>
                  <option value="100">100 / page</option>
                  <option value="500">500 / page</option>
                </select>
              </div>

              <div className="table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>#</th>

                      <th>Phone</th>
                      <th>User</th>
                      <th>UPI ID</th>
                      <th>Account Number</th>
                      <th>QR Code</th>
                      <th>Amount</th>
                      <th>Status</th>
                      <th>Reason</th>
                      <th>Action</th>
                      <th>Approved Time</th>
                      <th>Request Time</th>
                    </tr>
                  </thead>

                  <tbody>
                    {user &&
                      user.map((data, key) => {
                        return (
                          <tr key={data?._id || key}>
                            <td>{key + 1}</td>

                            <td>
                              <span className="pl-2">
                                {data?.User_id ? data?.User_id.Phone : ""}
                              </span>
                            </td>
                            <td>
                              {data?.User_id && (
                                <Link
                                  className="btn btn-sm btn-outline-info"
                                  to={`/user/view_user/${data?.User_id._id}`}
                                >
                                  {data?.User_id.Name}
                                </Link>
                              )}
                            </td>

                            <td>
                              <span className="pl-2">
                                {data?.upiId ?? "----"}
                              </span>
                            </td>
                            <td>
                              <span className="pl-2">
                                {data?.account_number ?? "----"}
                              </span>
                            </td>
                            <td>
                              {data?.paymentImage ? (
                                <a
                                  href={mediaUrl(data.paymentImage)}
                                  target="_blank"
                                  rel="noreferrer"
                                  title="Open withdrawal QR code"
                                >
                                  <img
                                    src={mediaUrl(data.paymentImage)}
                                    alt="Withdrawal QR code"
                                    style={{
                                      width: 56,
                                      height: 56,
                                      objectFit: "cover",
                                      borderRadius: 6,
                                      border: "1px solid #dee2e6",
                                    }}
                                  />
                                </a>
                              ) : (
                                "----"
                              )}
                            </td>

                            <td>{data?.amount}</td>
                            <td className="font-weight-bold text-success">
                              {data?.status === "none"
                                ? "Proccessing"
                                : data?.status}
                            </td>
                            <td>
                              <span className="pl-2">{data?.txn_msg}</span>
                            </td>
                            {/* <td>
                              {data?.status == "pending" &&
                              parseInt(gameCreatedAt) + 72000 < currentTime ? (
                                <button
                                  className="btn btn-danger"
                                  onClick={() =>
                                    universalCheckPayout(
                                      data?.payment_gateway,
                                      data?._id,
                                      data?.referenceId,
                                      data?.User_id?._id,
                                    )
                                  }
                                >
                                  Check {data?.payment_gateway}
                                </button>
                              ) : (
                                "Checked All or Wait"
                              )}
                            </td> */}

                            <td>
                              {data?.action_by && (
                                <Link
                                  className="btn btn-sm btn-outline-info"
                                  to={`/Agent/Data/${data?.action_by._id}`}
                                >
                                  {data?.action_by.Name}
                                </Link>
                              )}
                            </td>
                            <td>{dateFormat(data?.updatedAt).split(",")[0]}</td>
                            <td>{dateFormat(data?.createdAt).split(",")[0]}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>

              <div className="mt-4">
                <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  pageCount={numberOfPages}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination justify-content-center"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  activeClassName={"active"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SucWithdraw;
